import * as React from 'react'

/**
 * @description Phone icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Phone } from '@sravni/design-system-icons'
 *
 * <Phone />
 * ```
 */
export const Phone = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="Phone" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.046 10.953A10.528 10.528 0 0 1 6.848 7.78a.624.624 0 0 1 .138-.689l.683-.682c.56-.559.56-1.35.07-1.838l-.978-.978a1.666 1.666 0 0 0-2.356 0l-.544.543c-.617.617-.875 1.508-.708 2.392.412 2.177 1.677 4.561 3.718 6.602 2.04 2.041 4.425 3.306 6.602 3.718.883.166 1.774-.091 2.392-.709l.542-.542c.651-.651.651-1.706 0-2.357l-.977-.977a1.25 1.25 0 0 0-1.768 0l-.752.753a.624.624 0 0 1-.69.138 10.55 10.55 0 0 1-3.174-2.2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
